import { AutoAwesome } from 'components/icons';
import { cn } from 'utils/cn';

/** Its tile and glyph: the panel's header, the phone's header and the status line of a running answer. */
const SIZES = {
    header: { tile: 'size-7 rounded-lg', glyph: 'size-[18px]' },
    phone: { tile: 'size-8 rounded-[9px]', glyph: 'size-[18px]' },
    status: { tile: 'size-6 rounded-md', glyph: 'size-3.5' },
};

/**
 * The Crespect AI mark: the Material `AutoAwesome` glyph, never swapped or redrawn, on the AI wash, the colours of
 * the new sidebar's Ask Crespect AI row. It stands still. The wash exists only in the new design, so it draws inside
 * an AI surface's scope.
 */
export function AiMark({ size, className }: { size: keyof typeof SIZES; className?: string }) {
    return (
        <span
            aria-hidden
            className={cn('bg-ai-wash text-ai grid shrink-0 place-items-center', SIZES[size].tile, className)}
        >
            <AutoAwesome className={SIZES[size].glyph} />
        </span>
    );
}
